<template>
    <div class="tabs horizontal ">
        <div class="w-100 flex align-items-center" :class="[`justify-content-${position}`]">
            <ul class="tab-list" role="tabList" :class="[type]">
                <li 
                    v-for="(tab, index) in tabs"
                    :key="tab.id"
                    class="tab-list__item gap-2"
                    :class="[
                        `text--${size}`,
                        selectedIndex === index ? 'active' : '',
                    ]" 
                    tabIndex="0"
                    role="tabItem" 
                    :aria-selected="selectedIndex === index ? true : false"
                    @click="getCurrentTab(index)"
                >
                    <template v-if="isIcon && tab.iconName">
                        <IconSvg 
                            :name="tab.iconName" :fill="tab.iconFill" 
                            :width="getIconSize()" :height="getIconSize()" 
                        />
                    </template>
                    <span>{{ tab.name }}</span>
                    <span v-if="showCount || tab.showCount" class="zm__count__badge text--xs">{{ count || tab.count }}</span>
                </li>
            </ul>
        </div>
        
        <slot name="nonLinkedTab" v-bind="currentTab" />
    </div>
</template>

<script>
import IconSvg from "../icons/Icon-Svg.vue";

export default {
    name: "NonLinkedTabs",
    
    components: { IconSvg },
    
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        isIcon: {
            type: Boolean,
            default: false,
        },
        type: { 
            type: String, 
            default: "line",
            validator: (value) => {
                return ["line", "pill"].includes(value);
            },
        },
        position: { 
            type: String, 
            default: "start",
            validator: (value) => {
                return ["start", "center", "end"].includes(value);
            },
        },
        size: { 
            type: String, 
            default: "sm",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },
        showCount: {
            type: Boolean,
            default: false,
        },
        count: { 
            type: Number, 
            default: undefined,
        },
    },

    emits: ["select"],

    data() {
        return {
            selectedIndex: 0, // the index of the selected tab,
            tabs: this.list, 
            currentTab: {
                index: 0,
                name: "",
                component: "",
                isActive: false,
                route: "",
            },
        };
    },

    mounted() {
        this.getCurrentTab(0);
    },

    methods: {
        getCurrentTab(i) {
            this.selectedIndex = i;
            
            this.tabs.forEach((tab, index) => {
                tab.isActive = (index === i);

                if (index === i) {
                    this.currentTab = {
                        index: index,
                        name: tab.name,
                        component: tab.component,
                        isActive: tab.isActive,
                    };
                    this.$emit("select", this.currentTab);
                }
            });
        },

        getIconSize() {            
            switch (this.size) {
            case "xs": return "12px";
            case "sm": return "16px";
            case "md": return "24px";
            case "lg": return "36px";
            
            default: return "12px";
            }
        },
    },
};
</script>